import { makeStyles } from '@mui/styles';

export const useNavLinkStyles = makeStyles((theme) => ({
  tnLinkWrapper: {
    marginRight: '30px',
    [theme.breakpoints.down('lg')]: {
      marginRight: 0,
      textAlign: 'center',
    },
    '&:last-child': {
      marginRight: 0,
    },
  },
  tnLink: {
    cursor: 'pointer',
    textTransform: 'capitalize',
    transition: 'transform 200ms',
    fontWeight: 700,
    '&:hover': {},
  },

  linkActive: {
    padding: '10px 0',
    borderBottom: `2px solid ${theme.palette.primary.main}`,
  },
}));
